import {BracketsTabModel} from "../brackets.tab-model";
import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitionBracketsPageLinkModel} from "../../../../../containers/competition-container/pages/brackets-page/models/competition-brackets-page.link-model";

export class CompetitionBracketsPageTabModel extends BracketsTabModel {
  @computed get linkModel(): CompetitionBracketsPageLinkModel {
    const linkModel: CompetitionBracketsPageLinkModel = new CompetitionBracketsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.brackets;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_brackets';
  }
}
